import axios from "axios";
export default {
    deleteWorkSpace: (workSpaceId) => axios.post("/WorkSpaces/DeleteWorkSpace", { Id: workSpaceId })
};
